
import React, { useState, useMemo } from 'react';

const Step4_UserInfo = ({ formData, handleChange, nextStep, prevStep, captcha, handleCaptchaChange }) => {

  return (
    <div>
      <h2 className="text-2xl font-semibold text-gray-700 mb-6">Étape 4 : Vos informations</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        
        <div className="md:col-span-2">
          <label htmlFor="name" className="block text-sm font-medium text-gray-600 mb-1">Nom et Prénom</label>
          <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} placeholder="Ex: Jean Dupont" className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition" />
        </div>

        <div>
          <label htmlFor="email" className="block text-sm font-medium text-gray-600 mb-1">Email</label>
          <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} placeholder="Ex: jean.dupont@email.com" className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition" />
        </div>

        <div>
          <label htmlFor="phone" className="block text-sm font-medium text-gray-600 mb-1">Téléphone</label>
          <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} placeholder="Ex: 06 12 34 56 78" className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition" />
        </div>

        <div className="md:col-span-2">
          <label htmlFor="postalCode" className="block text-sm font-medium text-gray-600 mb-1">Code postal</label>
          <input type="text" id="postalCode" name="postalCode" value={formData.postalCode} onChange={handleChange} placeholder="Ex: 75001" className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition" />
        </div>

        {/* Anti-spam Captcha */}
        <div className="md:col-span-2">
            <label htmlFor="captcha" className="block text-sm font-medium text-gray-600 mb-1">
                Sécurité : Que fait {captcha.num1} + {captcha.num2} ?
            </label>
            <input type="number" id="captcha" name="captcha" value={captcha.answer} onChange={handleCaptchaChange} placeholder="Votre réponse" className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition" />
        </div>

        <div className="md:col-span-2 flex items-start mt-4">
            <input
                id="acceptGdpr"
                name="acceptGdpr"
                type="checkbox"
                checked={formData.acceptGdpr}
                onChange={handleChange}
                className="h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500 mt-1"
            />
            <div className="ml-3 text-sm">
                <label htmlFor="acceptGdpr" className="text-gray-600">
                    En cochant cette case, je confirme avoir lu et accepté la politique de confidentialité et j'accepte que mes données soient utilisées pour recevoir une proposition commerciale.
                </label>
            </div>
        </div>

      </div>

      <div className="mt-8 flex justify-between">
        <button type="button" onClick={prevStep} className="px-8 py-3 bg-gray-200 text-gray-800 font-semibold rounded-lg hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 transition-colors">
          Précédent
        </button>
        <button type="button" onClick={nextStep} className="px-8 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors" disabled={!formData.acceptGdpr}>
          Voir le résumé
        </button>
      </div>
    </div>
  );
};

export default Step4_UserInfo;
